<script lang="ts" setup>
import { computed } from 'vue'

import { useTracksLiveKit } from '@hooks/classroom/tracks-live-kit.hook'
import { useRoomLiveKit } from '@hooks/classroom/room-live-kit.hook'
import { useLessonRoomAnalytics } from '@hooks/lesson-room/lesson-room-analytics.hook'

import LessonRoomControlButton from '@Atoms/LessonRoom/LessonRoomControlButton.vue'

defineOptions({
  name: 'LiveKitButtonShare',
})

const { isLocalScreenSharing, toggleScreenShare } = useTracksLiveKit()
const { connectionState } = useRoomLiveKit()
const { trackClickShare } = useLessonRoomAnalytics()

const isConnected = computed<boolean>(() => connectionState.value === 'connected')

const handleClick = (): void => {
  trackClickShare()
  void toggleScreenShare()
}
</script>

<template>
  <LessonRoomControlButton
    :icon="{ name: 'screencast' }"
    label="Share"
    :enabled="isLocalScreenSharing"
    :disabled="!isConnected"
    @click="handleClick"
  />
</template>
